const baseUrl = "UserDocument";

export const updatePassportUrl = (userId) =>
	`${baseUrl}/upload-passport${userId ? `?userId=${userId}` : ""}`;
export const uploadSignatureUrl = (userId) =>
	`${baseUrl}/upload-signature?userId=${userId}`;
